<style lang="sass" scoped>
  .layout
    margin: 0 auto
    margin-top: 20px
    margin-bottom: 40px
    width: 1170px !important
    min-height: 400px
    padding: 40px 60px 100px 60px
    background-color: #fff
</style>

<template lang="pug">
.layout
  slot(name="page")
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// layout.vue?24e21676